import { createContext, ReactNode } from "react";

interface KeyContextType {
  functionKey: string;
  username: string;
}

const UrlParamsContext = createContext<KeyContextType>({
  functionKey: "",
  username: "",
});

interface UrlParamsProviderProps {
  children: ReactNode;
  functionKey: string;
  username: string;
}

function UrlParamsProvider({
  children,
  functionKey,
  username,
}: UrlParamsProviderProps) {
  return (
    <UrlParamsContext.Provider value={{ functionKey, username }}>
      {children}
    </UrlParamsContext.Provider>
  );
}

export { UrlParamsContext, UrlParamsProvider };
